import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { toast } from "sonner";
import { submitChecklist } from "../../lib/api";
import { Download, Loader2 } from "lucide-react";

export default function DownloadChecklistModal({ open, onOpenChange }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "" });
  const c = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Name and email are required");
      return;
    }
    setLoading(true);
    try {
      const { data } = await submitChecklist({ ...form, checklist: "cyber-readiness-checklist" });
      toast.success(data.message);
      onOpenChange(false);
      setForm({ name: "", email: "", phone: "", company: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="download-checklist-modal">
        <DialogHeader>
          <div className="inline-flex items-center gap-2 text-primary text-sm font-semibold">
            <Download className="h-4 w-4" /> Free Download
          </div>
          <DialogTitle className="text-2xl">Cybersecurity Readiness Checklist</DialogTitle>
          <DialogDescription>A 30-point executive checklist mapped to ISO 27001 & NIST CSF 2.0. Enter your details to receive it.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 pt-2">
          <div>
            <Label htmlFor="dl-name">Full name*</Label>
            <Input id="dl-name" data-testid="dl-name-input" value={form.name} onChange={c("name")} required />
          </div>
          <div>
            <Label htmlFor="dl-email">Work email*</Label>
            <Input id="dl-email" data-testid="dl-email-input" type="email" value={form.email} onChange={c("email")} required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="dl-phone">Phone</Label>
              <Input id="dl-phone" data-testid="dl-phone-input" value={form.phone} onChange={c("phone")} />
            </div>
            <div>
              <Label htmlFor="dl-company">Company</Label>
              <Input id="dl-company" data-testid="dl-company-input" value={form.company} onChange={c("company")} />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="dl-submit-btn" className="w-full bg-secondary hover:bg-secondary/90 rounded-full h-11 text-secondary-foreground">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Get the Checklist"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
